import type { z } from 'zod';
import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createTransformer } from '../common/utils';
import { DBNoteSchema, NoteSchema } from './schemas';

type Note = z.infer<typeof NoteSchema>;

export const NoteCodecConfig: TransformerConfig<typeof NoteSchema, typeof DBNoteSchema> = {
  name: 'Note',
  clientSchema: NoteSchema,
  dbSchema: DBNoteSchema,
  transformers: [
    // subject + category + key → noteId composite key
    // noteId is removed on decode (subject, category, key are already present)
    createTransformer<typeof NoteSchema, typeof DBNoteSchema>({
      encoder: {
        sourceFields: ['subject', 'category', 'key'] as const,
        dependencies: ['subject', 'category', 'key'] as const,
        encode: ({ subject, category, key }) => ({
          noteId: `${subject as Note['subject']}#${category as Note['category']}#${key as Note['key']}`,
          subject,
          category,
          key,
        }),
      },
      decoder: {
        sourceFields: ['noteId'] as const,
        decode: () => ({}), // noteId is not needed on client side, other fields already present
      },
    }),
  ],
};

export const encodeNoteToDb = createEncodeToDbFn(NoteCodecConfig);
export const decodeNoteFromDb = createDecodeFromDbFn(NoteCodecConfig);
